module.exports = __webpack_public_path__ + "static/media/ico-googlepodcasts.0abbeef2.svg";